import { useDeepCompareEffect } from 'react-use';
import { customFieldsApi } from 'apis/customFields';
import { elevionCustomAttributePrefix, elevionSystemAttributePrefix, elevionSystemAttributesDataType, } from 'utils/elevion';
/**
 * Checks if custom fields are visible based on their conditional visibility
 * status. It tracks the changes in the custom attributes and system context and
 * returns the new visibility status.
 *
 * @returns An object mapping custom field ids to their visibility status.
 */
export const useCustomFieldsVisibility = (customFields, systemContext, options = {}) => {
    var _a, _b;
    const [readVisibility, visibilityResponse] = customFieldsApi.useLazyReadVisibilityQuery();
    useDeepCompareEffect(() => {
        const systemContextNormalized = Object.fromEntries(Object.entries(systemContext).map(([key, value]) => [
            `${elevionSystemAttributePrefix}${key}`,
            {
                data_type: elevionSystemAttributesDataType[key],
                value,
            },
        ]));
        readVisibility({
            entityId: customFields[0].attribute.entity_id,
            params: { include_archived: options.includeArchived },
            context: customFields.reduce((context, customField) => {
                return Object.assign(Object.assign({}, context), { [`${elevionCustomAttributePrefix}${customField.attribute.identifier}`]: customField.value });
            }, systemContextNormalized),
        });
    }, [customFields, systemContext]);
    return (_b = (_a = visibilityResponse.data) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {};
};
